import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";
import {map, tap} from 'rxjs/operators';
import {Cheque} from "../models/cheque.model";
import {PhoneCountryCode} from '../models/phone-country-code.model';
import {TransactionType} from '../models/transaction-type.model';
import {BusinessDocumentTypeModel} from '../models/business-document-type.model';
import { SocialLinksMapped, SocialLinksModel } from '../models/social-links.model';
import { ScoreModel } from '../models/score.model';

@Injectable({
  providedIn: 'root'
})
export class MastersApiService {

  private banksUrl:string = environment.apiBaseUrl+"/core/masters/banks";
  private tipoChequeUrl:string = environment.apiBaseUrl+"/core/masters/cheques_types";

  constructor(
    private http: HttpClient
  ) { }

  getBankList(): Observable<any> {
      return this.http.get<any>(this.banksUrl);
  }

  getTipoChequeList(): Observable<any> {
    return this.http.get<any>(this.tipoChequeUrl);
  }
  getDocumentationLinks(userType) {
    return this.http.get<any>(environment.apiBaseUrl+`/core/masters/links/additional_documents/${userType}`)
  }
  getInstructiveById(instructiveId: string): Observable<any> {
    return this.http.get<any>( environment.apiBaseUrl + `/core/masters/instructives/${instructiveId}`, {});
  }
  getInstructionTypeList(): Observable<any>{
    // return this.http.get<any>(environment.apiBaseUrl + `/core/masters/instructions_types`);
    return this.http.get<any>(environment.apiBaseUrl + `/core/masters/instructives/find_actives`);
  }
  getEstadoChequeList(): Observable<any> {
    return this.http.get<any>(environment.apiBaseUrl + '/core/masters/cheques_status');
  }
  getAllCountriesList(): Observable<PhoneCountryCode[]> {
    return this.http.get<any>(environment.apiBaseUrl + '/accounts/public/countries');
  }
  getTransactionsTypesList(): Observable<TransactionType[]> {
    return this.http.get<any>( environment.apiBaseUrl + '/core/masters/transactions_types');
  }
  getBusinessDocumentTypes(): Observable<BusinessDocumentTypeModel[]> {
    return this.http.get<any>(environment.apiBaseUrl + '/core/masters/business_document_types');
  }
  getDocumentsType(): Observable<string[]> {
    return this.http.get<any>(environment.apiBaseUrl + '/accounts/public/document_types');
  }
  getChequeOfertaStatus(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiBaseUrl + `/core/masters/cheques_ofertas_status`);
  }
  getSocialMediaLinks(): Observable<SocialLinksMapped> {
    return this.http.get<SocialLinksModel[]>(environment.apiBaseUrl + `/core/portal/profile/social_media`).pipe(
      map((response: SocialLinksModel[]) => {
        return response.reduce((acc: { [key: string]: SocialLinksModel }, item: SocialLinksModel) => {
          acc[item.id.toLowerCase()] = item;
          return acc;
        }, {});
      }),
    );
  }
  getQualifications(): Observable<ScoreModel[]> {
    return this.http.get<ScoreModel[]>(environment.apiBaseUrl + `/bo/masters/qualifications`);
  }
}


